import { Link } from "react-router-dom";
import { EncrelioLogo } from "@/components/Logo";
import { appConfig } from "@/config/app";
import { BRAND } from "./brand";
import { CtaLink } from "./CtaLink";

const { contactEmail, partnersEmail, privacyEmail } = appConfig;

const COLUMNS: Array<{
  title: string;
  links: Array<{ label: string; to: string }>;
}> = [
  {
    title: "Produit",
    links: [
      { label: "Fonctionnement", to: "/#fonctionnement" },
      { label: "Mise en demeure", to: "/#mise-en-demeure" },
      { label: "Connexions", to: "/#connexions" },
      { label: "Tarifs", to: "/tarifs" },
    ],
  },
  {
    title: "Cabinets",
    links: [
      { label: "Marque blanche", to: "/#cabinets" },
      { label: "Programme cabinets", to: `mailto:${partnersEmail}` },
    ],
  },
  {
    title: "Contact",
    links: [
      { label: contactEmail, to: `mailto:${contactEmail}` },
      { label: partnersEmail, to: `mailto:${partnersEmail}` },
      { label: "Données personnelles", to: `mailto:${privacyEmail}` },
    ],
  },
  {
    title: "Légal",
    links: [
      { label: "Confidentialité", to: "/legal/confidentialite" },
      { label: "Conditions", to: "/legal/cgu" },
      { label: "Sous-traitants", to: "/legal/sous-traitants" },
    ],
  },
];

const LINK =
  "inline-flex min-h-9 cursor-pointer items-center rounded-sm text-sm text-muted-foreground transition-colors duration-150 hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring";

function FooterLink({ label, to }: { label: string; to: string }) {
  return to.startsWith("mailto:") ? (
    <a href={to} className={LINK}>
      {label}
    </a>
  ) : (
    <Link to={to} className={LINK}>
      {label}
    </Link>
  );
}

export function MarketingFooter() {
  return (
    <footer className="border-t border-border bg-surface">
      <div className="mx-auto max-w-[1200px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
        <div className="flex flex-col items-start justify-between gap-8 border-b border-border pb-12 lg:flex-row lg:items-end">
          <div>
            <Link
              to="/"
              aria-label={`${BRAND}, accueil`}
              className="group -m-2 inline-flex cursor-pointer rounded-lg p-2 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring"
            >
              <EncrelioLogo height={30} />
            </Link>
            <p className="mt-5 max-w-[22ch] font-display text-[clamp(1.6rem,3vw,2.2rem)] leading-[1.1] font-semibold tracking-[-0.012em] text-foreground">
              Relancez vos clients. Pas votre relation.
            </p>
          </div>
          <CtaLink to="/signup" arrow>
            Créer un compte
          </CtaLink>
        </div>

        <div className="grid grid-cols-2 gap-x-6 gap-y-10 pt-12 md:grid-cols-4">
          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h2 className="text-xs font-semibold tracking-[0.14em] text-foreground uppercase">
                {col.title}
              </h2>
              <ul className="mt-4 space-y-0.5">
                {col.links.map((link) => (
                  <li key={link.label} className="break-all sm:break-normal">
                    <FooterLink {...link} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-border pt-8 text-caption text-subtle-foreground md:flex-row md:items-start md:justify-between">
          <p>
            © {new Date().getFullYear()} Nestone. Édité par Nestone, entreprise individuelle
            (micro-entrepreneur).
          </p>
          <p className="md:text-right">
            SIREN 922 226 428 · Besançon, France
            <br />
            TVA non applicable, art. 293 B du CGI
          </p>
        </div>
      </div>
    </footer>
  );
}
